<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('goods_label_orderGoodsNo') || '产品编号'">
            <el-input v-model="formData.orderGoodsNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('goods_label_identifyGoodsNo') || '产品识别编号'"
          >
            <el-input v-model="formData.identifyGoodsNo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="18">
          <el-form-item :label="$l('goods_label_orderGoodsName') || '产品名称'">
            <el-input v-model="formData.orderGoodsName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('goods_label_isGroup') || '是否套装'">
            <el-input v-model="formData.isGroup" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_package_size_label_goodsLength') || '长'"
            prop="goodsLength"
          >
            <el-input-number
              v-model="formData.goodsLength"
              :placeholder="
                $l('tips_goods_package_size_label_goodsLength') || '请输入长'
              "
              controls-position="right"
              style="width:100%"
              :max="999999"
              :min="0"
              :step="0.01"
              :precision="2"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_package_size_label_goodsWidth') || '宽'"
            prop="goodsWidth"
          >
            <el-input-number
              v-model="formData.goodsWidth"
              :placeholder="
                $l('tips_goods_package_size_label_goodsWidth') || '请输入宽'
              "
              controls-position="right"
              style="width:100%"
              :max="999999"
              :min="0"
              :step="0.01"
              :precision="2"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_package_size_label_goodsHeight') || '高'"
            prop="goodsHeight"
          >
            <el-input-number
              v-model="formData.goodsHeight"
              :placeholder="
                $l('tips_goods_package_size_label_goodsHeight') || '请输入高'
              "
              controls-position="right"
              style="width:100%"
              :max="999999"
              :min="0"
              :step="0.01"
              :precision="2"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_package_size_label_goodsWeight') || '净重'"
            prop="goodsWeight"
          >
            <el-input-number
              v-model="formData.goodsWeight"
              :placeholder="
                $l('tips_goods_package_size_label_goodsWeight') || '请输入净重'
              "
              controls-position="right"
              style="width:100%"
              :max="999999"
              :min="0"
              :step="1"
              :precision="0"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
// import ChoicePackageInput from '../choice-package/input.vue'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    orderGoodsCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      englishSizeDictParams: { dictType: 'englishSize' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      rules: {
        goodsLength: [
          {
            required: true,
            message:
              this.$l('tips_goods_package_size_label_goodsLength') ||
              '请输入长度',
            trigger: 'blur',
          },
        ],
        goodsWidth: [
          {
            required: true,
            message:
              this.$l('tips_goods_package_size_label_goodsWidth') ||
              '请输入宽度',
            trigger: 'blur',
          },
        ],
        goodsHeight: [
          {
            required: true,
            message:
              this.$l('tips_goods_package_size_label_goodsHeight') ||
              '请输入高度',
            trigger: 'blur',
          },
        ],
        goodsWeight: [
          {
            required: true,
            message:
              this.$l('tips_goods_package_size_label_goodsWeight') ||
              '请输入净重',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderGoodsCode) return
      this.$api
        .orderGoodsPackageSizeDetailApi({
          orderGoodsCode: this.orderGoodsCode,
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const parms = { ...this.formData, orderCode: this.orderCode }
      this.loadingOpen()
      this.$api
        .orderGoodsPackageSizeEditSaveApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
